// Styles
import './index.less';

// Libraries
import React from 'react';

// Services
import LANG from './lang.js';

// Components
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import Section from 'ck-core-client/source/components/Layout/Section';

const ProgressionInfo = ({ badge }) =>
	Object.entries(badge.progressionKeys).map(
		key =>
			badge.progressionKeys[key[0]] ? (
				<div className="BadgesTooltipContent__progression" key={key[0]}>
					<div className="BadgesTooltipContent__progressionKey__wrapper">
						<div
							className="BadgesTooltipContent__progressionKey"
							style={{
								background: badge.progressionKeys[key[0]] && badge.progressionKeys[key[0]].COLOUR,
								color:
									(badge.progressionKeys[key[0]] && badge.progressionKeys[key[0]].TEXT_COLOUR) ||
									'#000000'
							}}
						>
							{key[0]}
						</div>
					</div>
					<div className="BadgesTooltipContent__description">
						{badge.progressionKeys[key[0]].DESCRIPTION}
					</div>
				</div>
			) : null
	);

const BadgesTooltipContent = ({ badge }) => {
	const badgeTitle = badge.badgeId.substring(0, badge.badgeId.length - 2);
	const hasProgressInfo = badge.progressionKeys && Object.keys(badge.progressionKeys).length !== 0;

	return (
		<Section borderColor="none" color="none">
			<div className="BadgesTooltipContent">
				<div className="BadgesTooltipContent__header">
					<div className="BadgesTooltipContent__header__title"> {badgeTitle} </div>
					<ReactCKImage name={badge.icon} options={{ ignoreDimensions: true }} />
					<div className="BadgesTooltipContent__header__rarity">
						{LANG.HEADINGS[badge.rarity.toUpperCase()]}
					</div>
				</div>
				<div className="BadgesTooltipContent__content">
					{badge.unlocked &&
						hasProgressInfo && (
							<div className="BadgesTooltipContent__intro">{LANG.PROGRESSION_INTRO}</div>
						)}
					{hasProgressInfo && (
						<div className="BadgesTooltipContent__progressionInfo">
							<ProgressionInfo badge={badge} />
						</div>
					)}
				</div>
			</div>
		</Section>
	);
};

export default BadgesTooltipContent;
